export const CONTACT_EMAIL = "hello@saasradarhub.com";
export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}`;
export const partnershipMailto = (subject = "Partnership inquiry") =>
  `${CONTACT_MAILTO}?subject=${encodeURIComponent(subject)}`;
